import { Component, Inject, OnInit } from "@angular/core";
import {  DomSanitizer,  SafeUrl} from "@angular/platform-browser";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT } from "@angular/common";
import { Pagination } from "../../../model/pagination";
import { TransactionService } from "../../../services/transaction.service";
import { ConstantService } from "../../../constant/constant-service";
import { PPQTracking } from "../../../model/ppq-tracking";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "e-tracking-old",
  templateUrl: "./e-tracking-old.component.html",
  styleUrls: ["./e-tracking-old.component.css"],
})
export class ETrackingComponentOld implements OnInit {
  src: string;
  prefix: string;
  numberCns: string;
  submitted: boolean;
  myTrustedURL: SafeUrl;
  showButton: boolean;
  urlTree: any;
  trkTxnValue: any;
  listTracking: PPQTracking[];
  Tracking: PPQTracking;
  pagination: Pagination;
  showPPQ: boolean;
  showPPQStart: boolean;
  showPPQFinished: boolean;
  window: any;


  constructor(private sanitizer: DomSanitizer, private router: Router,    private transactionService: TransactionService ,
    private messageService: MessageService , private translateService: TranslateService , private constantService: ConstantService,
    @Inject(DOCUMENT) private _document: any) {
    this.myTrustedURL = sanitizer.bypassSecurityTrustUrl(this.src);
    this.urlTree = this.router.parseUrl(this.router.url);
    this.trkTxnValue = this.urlTree.queryParams["trkTxnValue"];
    this.pagination = new Pagination();
    this.pagination.pageSize = 50;
    this.pagination.pageNo = 0;
    this.pagination.orderTable = [];
    this.showPPQ = false;
    this.GetAWBDetail();
    this.showPPQ = false;
    this.showPPQStart = false;
    this.showPPQFinished = false;
    this.window = _document.defaultView;
    this.executeQualtricsSurvey();
  }

  ngOnInit(): void {
    this.src =
    `${environment.IBSUrl}${this.trkTxnValue}`;
    (<HTMLIFrameElement>document.getElementById("Iframe")).src = this.src;
  }

  GetAWBDetail(){

    let awb = this.trkTxnValue.toString().split("-");

    this.transactionService
      .GetList(
        environment.PPQAPI,
        this.constantService.PPQ_FLIGHT+"/getAWBDetails","?ShipmentPrefix="+awb[0]+"&MasterDocumentNumber="+awb[1]    
      )
      .subscribe(
        (data) => {
          if (data.responseDto.response === this.constantService.RESPONSE_OK) {
            this.listTracking = [];
            this.listTracking = data.businessDto;
            if(this.listTracking[0].commodityFlowers){
              
              this.Tracking = new PPQTracking();
              this.Tracking = this.listTracking[0];
              this.showPPQ = this.Tracking?.ppqstarted != null;
              this.showPPQStart = this.Tracking?.ppqstarted != null ;
              this.showPPQFinished = this.Tracking?.ppqfinished != null ;
              
            }
          } 
        }        
      );

      
  }

  executeQualtricsSurvey() {
    setTimeout(() => {
      if (typeof this.window.QSI !== 'undefined' || typeof this.window.QSI.API !== 'undefined') {
        this.window.QSI.API.load();
        this.window.QSI.API.run();
      }
    }, 5000);
  }
}
